var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStair(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "200mm",
    height: "200mm",
    viewBox: "0 0 200 200",
    id: "svg1",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(-58.343095,-57.486621)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2",
    transform: "translate(0,-0.00137765)",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none",
      strokeOpacity: 1
    },
    d: "m 113.62757,235.47257 0.0666,-77.98595 0.0666,-77.985944 h 9.65729 9.65729 l 0.0695,9.458854 0.0695,9.458855 h 25.12874 25.12874 l 0.0695,-9.458855 0.0695,-9.458854 h 9.65729 9.6573 l 0.0666,77.985944 0.0666,77.98595 z m 11.37797,-74.08334 V 87.305884 h -1.5875 -1.5875 v 74.083346 74.08334 h 1.5875 1.5875 z m 58.47293,68.52709 v -5.55625 h -25.13542 -25.13543 v 5.55625 5.55625 h 25.13543 25.13542 z m 11.37708,-68.52709 V 87.305884 h -1.5875 -1.5875 v 74.083346 74.08334 h 1.5875 1.5875 z m -11.37708,51.46146 v -3.57187 h -25.13542 -25.13543 v 3.57187 3.57188 h 25.13543 25.13542 z m 0.0559,-17.06588 0.0764,-5.5565 h -25.26772 -25.26772 l 0.0764,5.5565 0.0764,5.55651 h 25.11499 25.11499 z m -0.004,-17.19812 0.0808,-3.44005 h -25.26812 -25.26772 l 0.0808,3.44005 0.0809,3.44004 h 25.106 25.106 z m 0.0808,-17.19758 v -5.55625 l -25.26771,1e-5 h -25.26772 v 5.55625 5.55624 l 25.26772,-1e-5 h 25.26771 z m -0.0808,-17.19734 -0.0809,-3.44005 h -25.106 -25.10601 l -0.0809,3.44005 -0.0808,3.44004 h 25.26772 25.26771 z m 0.004,-17.19813 -0.0764,-5.5565 h -25.11492 -25.115 l -0.0764,5.5565 -0.0764,5.55651 h 25.26772 25.26771 z m -0.0559,-17.06588 v -3.57187 h -25.13542 -25.13543 v 3.57187 3.57188 h 25.13543 25.13542 z",
    id: "path1"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.259264,
      strokeOpacity: 1
    },
    id: "rect2",
    width: 19.275732,
    height: 7.1640487,
    x: 113.75824,
    y: 228.18164
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.259264,
      strokeOpacity: 1
    },
    id: "rect2-2",
    width: 19.275732,
    height: 7.1640487,
    x: 183.62445,
    y: 228.17165
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStair);
export default __webpack_public_path__ + "static/media/Stair.18aac1481864ab98a8eba492f25be40d.svg";
export { ForwardRef as ReactComponent };